import { apiClient } from '../lib/api/client'

export type LinkPropertyData = {
  propertyId: string
  ownerId: string
}

export type UnlinkPropertyData = Omit<LinkPropertyData, 'ownerId'>

type LinkPropertyResponse = {
  data: string
}

export class LinkPropertiesRepository {
  private functionName = 'link-properties'

  async link(
    linkPropertyData: LinkPropertyData
  ): Promise<LinkPropertyResponse> {
    return apiClient.invoke<LinkPropertyResponse>(`${this.functionName}`, {
      method: 'POST',
      body: linkPropertyData,
    })
  }

  async unlink(
    unlinkPropertyData: UnlinkPropertyData
  ): Promise<LinkPropertyResponse> {
    return apiClient.invoke<LinkPropertyResponse>(`${this.functionName}`, {
      method: 'DELETE',
      body: unlinkPropertyData,
    })
  }
}

export const linkPropertiesRepository = new LinkPropertiesRepository()
